import useApiRequest from "@/lib/hooks/use-request";
import { UserListPaginatedResponseDtoWithInvitationCount, UserListResponseDto } from "@/lib/interfaces/users";
import { Paginated, Pagination } from "@/lib/interfaces/utils";
import DataFetchParent from "@/ui-components/ui/data-fetch";
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import ApiKeyManager from "./api-key-manager";
import WebhooksDataTable from "./webhook-data-table";

const WebhooksFetcher = ({
  searchQuery,
  setReload,
  reload,
}: {
  searchQuery: string;
  setReload: Dispatch<SetStateAction<boolean>>;
  reload: boolean;
}) => {
  const [items, setItems] = useState<UserListResponseDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);
  const { apiRequest } = useApiRequest();
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: searchQuery.split("page=")[1] ? parseInt(searchQuery.split("page=")[1].split("&")[0]) - 1 : 0,
    pageSize: 3,
  });

  const [pageCount, setPageCount] = useState<number>(0);

  const getItemsInit = useCallback(async () => {
    setInitLoading(true);
    const response = await apiRequest<UserListPaginatedResponseDtoWithInvitationCount>("settings/users/initial", "GET");
    setInitLoading(false);
    if (response.data) {
      setItems(response.data.users.docs);
      setPageCount(response.data.users.pageCount);
    }
  }, [apiRequest]);

  const getItemsPaginated = useCallback(async () => {
    setIsLoading(true);
    let url = `settings/users?limit=${pagination.pageSize}&page=${pagination.pageIndex + 1}`;
    if (searchQuery) {
      url = `settings/users/search?limit=${pagination.pageSize}&page=${pagination.pageIndex + 1}&search=${searchQuery}`;
    }
    const response = await apiRequest<Paginated<UserListResponseDto>>(url, "GET");
    setIsLoading(false);
    if (response.data) {
      setItems(response.data.docs);
      setPageCount(response.data.pageCount);
    }
  }, [apiRequest, pagination.pageIndex, pagination.pageSize, searchQuery]);

  useEffect(() => {
    getItemsInit();
  }, [getItemsInit]);

  useEffect(() => {
    if (!initLoading) {
      getItemsPaginated();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, getItemsPaginated, searchQuery, reload]);

  const onRegenerate = async () => {
    setReload((prev) => !prev);
  };

  return (
    <DataFetchParent
      data={items}
      isLoading={isLoading || initLoading}
      renderElement={(response: UserListResponseDto[]) => (
        <div className="w-full p-4 flex flex-col gap-4">
          <ApiKeyManager apiKey={"1234567890"} onRegenerate={onRegenerate} />
          <hr />
          <WebhooksDataTable
            data={response}
            isLoading={isLoading || initLoading}
            pageCount={pageCount}
            pagination={pagination}
            setPagination={setPagination}
            setReload={setReload}
          />
          <hr />
          <WebhooksDataTable
            data={response}
            isLoading={isLoading || initLoading}
            pageCount={pageCount}
            pagination={pagination}
            setPagination={setPagination}
            setReload={setReload}
          />
          <hr />
          <WebhooksDataTable
            data={response}
            isLoading={isLoading || initLoading}
            pageCount={pageCount}
            pagination={pagination}
            setPagination={setPagination}
            setReload={setReload}
          />
        </div>
      )}
    />
  );
};

export default WebhooksFetcher;
